import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const deleteTenantFeatureFlag = (token, id) => {
    return fetch(`${apiUrl}tenant_feature_flags/${id}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default deleteTenantFeatureFlag